import { createContext } from "react";

export const LeagueContext = createContext({
  leagueCode: "",
  sponsorChecked: "",
  triggerClassicPublicLeagueRefetch: false,
  isLeagueMarketingPage: false,
  updateLeagueCode: () => {},
  updateSponsorChecked: () => {},
  updateTriggerClassicPublicLeagueRefetch: () => {},
  updateIsLeagueMarketingPage: () => {},
});
